// extracted by mini-css-extract-plugin
export var chevron = "_4g-d";
export var disabled = "_4g-b";
export var error = "_4g-c";
export var hideBorder = "_4g-1";
export var icon = "_4g-e";
export var input = "_4g-0";
export var large = "_4g-f";
export var open = "_4g-9";
export var placeholder = "_4g-a";
export var regular = "_4g-5";
export var singleRowInput = "_4g-2";
export var singleSelectInput = "_4g-3 _4g-0";
export var small = "_4g-4";
export var spinnerContainer = "_4g-i";
export var tag = "_4g-7";
export var tagsContainer = "_4g-8";
export var tagsInput = "_4g-6 _4g-0";
export var xSmall = "_4g-g";
export var xxSmall = "_4g-h";